module.exports = __webpack_public_path__ + "static/Belista-943930219530cd23e36b36206f0a8fcc.ttf";